import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-profile",
  "use": "icon-profile-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-profile\">\r\n\r\n<rect x=\"0\" fill=\"none\" width=\"24\" height=\"24\" />\r\n\r\n<g>\r\n\r\n<path d=\"M12 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 16s8 0 8-2c0-2.4-3.9-5-8-5s-8 2.6-8 5c0 2 8 2 8 2z\" />\r\n\r\n</g>\r\n\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol